// internal-deps
import { HTTP_METHODS, makeDownstreamApiCall } from "@swiggy-private/checkout-core";
import { ApiResponse, unwrapResponse } from "@swiggy-private/core-utils";
import { Err, Result } from "@swiggy-private/js-fp";

// constants
import { DOWNSTREAM_ENDPOINTS, DOWNSTREAM_HOSTS } from "@dineout-cart-client/constants";
import { format } from "@swiggy-private/js-utils";

// interfaces
import { IGetOutletsResponse } from "@dineout-cart-client/interfaces";

async function getOutletsValidityInfo(itemId: string, cartId: string): Promise<IGetOutletsResponse> {
    const endpoint = format(DOWNSTREAM_ENDPOINTS.FETCH_STEALDEAL_ITEM_OUTLET_VALIDITY_ENDPOINT, itemId, cartId);
    const response = (await makeDownstreamApiCall({
        apiHost: DOWNSTREAM_HOSTS.DO_HOST,
        endpoint,
        options: {
            method: HTTP_METHODS.GET,
        },
    })) as IGetOutletsResponse;

    return response;
}

export async function getOutletsValidityInfoWrapper(
    itemId: string,
    cartId: string,
): Promise<Result<IGetOutletsResponse["data"], string | Error>> {
    try {
        const response = await getOutletsValidityInfo(itemId, cartId);
        return unwrapResponse<IGetOutletsResponse["data"]>(response as ApiResponse<IGetOutletsResponse["data"]>);
    } catch (err) {
        return Err(err as Error);
    }
}
